<div style="overflow-x:hidden;">
<div class="landing-page-website-header">
    <app-website-header></app-website-header>
</div>
<div class="landing-page-carousel">
    <app-carousel></app-carousel>
</div>
<div class="count-down" *ngIf="counter" >
    <iframe id="myIframe" width="625" height="322" src="https://w2.countingdownto.com/5823103" frameborder="0"></iframe>
</div>
<div style="background-color: #f5f5f5;">
  <div *ngIf="products.length>0"  class="row">
    <div  class="d-flex align-items-center headers gap-2" style="margin-top: 29px;">
      <img
        src="../../../assets/images/products.svg"
        alt="landingpage"
        class="products ml-auto"
        style="margin-left: 1%"
        width="24px"
        height="24px"
      />
      <span class="products mx-2" style="font-weight: bolder; font-size:12; font-family: 'Georgia' !important;  "> Latest Products </span>
    </div>

    <div class="products-container d-flex flex-row flex-wrap mt-4" [style.gap.px]="desktop ? 30 : 0" style=" margin-left: 2%; width: 95%; ">
        <ng-container *ngFor="let product of products.slice(0, itemsToDisplay)">
            <div class="categories d-flex flex-column flex-wrap my-2 align-items-center"  style="flex: 1; margin: 0 10px;">

                <app-product-info-card
                    [id]="product.id"
                    [productImage]="product.images[0]"
                    [title]="product.productname"
                    [isCategoryCard]="false"
                    [subtitleImage]="product.oemlogo"
                    [hoverText]="product.description"
                    [contentItems]="product.specifications"
                    style="width: 260px; cursor: pointer; "
                    [oemId]="product.oemid"
                >
                </app-product-info-card>
            </div>
        </ng-container>
        <div class="d-flex justify-content-end pointer m-2 m-sm-2 view-more1-mobile-view  view-more-mobile-view-parent" style=" width: 98%;"  *ngIf="products.length>0"  >
            <button class="button-primary btn btn-primary mx-4 mx-sm-0  view-more-mobile-view"  style="font-family: 'Georgia' !important;font-weight: bold;" (click)="navigateToProductsView()">View All</button>
        </div>
    </div>

    <div class="four-d-banner" style="display: flex; justify-content: space-between; padding: 0; padding-top: 20px;">
        <div class="banner-l col-md-6 col-sm-12 ">
            <img src="../../assets/images/4d-banner.svg" alt="" width="100%" height="" style="width: 100%; height: 100%; object-fit: cover; object-position: center;" >
        </div>
        
        <div class="banner-r">
            <div  class="d-flex flex-column justify-content-center gap-4">
                <span class="banner-heading">Virtually Explore and Interact with Medical Equipment in an Immersive 4D Experience</span>
                <span class="para">We specialize in crafting next-generation 4D websites, brochures, and apps designed to showcase and market your medical devices and equipment with unparalleled impact. Our solutions go beyond stunning 3D and 4D visualizations, offering interactive tools for an immersive product experience. Integrated lead generation forms and advanced analytics empower data-driven decisions, enhancing your sales strategy. With our cutting-edge approach, you can captivate your customers and drive growth like never before.</span>
            </div>
            <button class="button-primary btn  mx-5 mx-sm-5 btn-primary view-more-mobile-view laptopView"   style="font-family: 'Georgia' !important;font-weight: bold; padding: 10px 40px ;" (click)="navigateTo4DDemo()">Click Here For Demo</button>
        </div>
    </div>

    <div>
        <div *ngIf="upcomingWebinars.length>0" class="row mt-1">
            <div  class="d-flex align-items-center mt-3 mb-4 headers gap-2">
                <img width="24px" height="24px" src="../../assets/images/icons/webinar-icon.svg" alt="landingpage" class="products ml-auto" style="margin-left: 1%;" />
                <span class="products mx-2" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important;"> Upcoming Webinars </span>
            </div>
        </div>
        <div>
            <div class="products-container upcoming-webinars-container d-flex flex-row flex-wrap" [style.gap.px]="desktop ? 110 : 0" >
                <ng-container *ngFor="let webinar of upcomingWebinars.slice(0, itemsToDisplay/2)">
                    <div class="categories upcomingWebinars">

                        <div class="d-flex card my-2" style="border: 1px solid #f5f5f5; box-shadow: 0px 4px 16px 0px #0000000d; width: 262px;" (click)="view(webinar.id)">
                            <div class="card-img">
                                <span class="sponsored_tag" *ngIf="webinar?.sponsored"><img src="../../../assets/images/ph_seal-check-fill.svg" alt="">Sponsored</span>
                                <img [src]="webinar.image" width="100%" height="130px" class="img-radius">
                            </div>
                            <div class="card-heading">
                                <p class="card-title-heading" > {{ webinar.webinarTitle | truncateText: originalTruncateText  }} </p>
                            </div>
                            <div class="card-info">
                                <div class="card-info-calender d-flex">
                                    <img src="../../../assets/images/icons/calender-icon-blue.svg" style="padding: 0px 5px;" />
                                    <div class="time-section">
                                        <p class="date-time">
                                            {{ (webinar?.webinarDate && webinar?.webinarTime) ? (webinar?.webinarDate + ' ' + webinar?.webinarTime) : 
                                               (webinar?.webinarDate ? webinar?.webinarDate : 'Will be announced soon') }}
                                        </p>
                                    </div>
                                </div>
                                <div class="card-info-person d-flex">
                                    <img [src]="webinar?.hostImage" class="person-img" style="max-width: 32px;" />

                                    <div class="d-flex flex-column justify-content-around elipses">
                                        <p class="person-name">{{ webinar?.speakersName }}</p>
                                        <p class="specialization m-0">{{ webinar?.speciality }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        <div *ngIf="upcomingWebinars.length>0" class="d-flex justify-content-end pointer m-2 m-sm-4  view-more-mobile-view-parent laptopViewParent">
            <button class="button-primary btn  mx-5 mx-sm-5 btn-primary view-more-mobile-view laptopView"   style="font-family: 'Georgia' !important;font-weight: bold;" [routerLink]="['/webinars']" >View All</button>
        </div>
        </div>

<div>
  <div *ngIf="rssData?.length>0" class="row mt-1 ">
    <div  class="d-flex align-items-center mt-4 mb-4  headers gap-2">
      <img
        src="../../../../assets/images/Frame.svg"
        alt="landingpage"
        class="products ml-auto"
        style="margin-left: 1%"
        width="24px"
        height="24px"
      />
      <span class="products mx-2 fw-bold" style="font-weight: bolder; font-size:12; font-family: 'Georgia' !important; "> News & Trends </span>
    </div>
</div>

 <div class="products-container d-flex flex-row flex-wrap justify-content-start" [style.gap.px]="desktop ? 32 : 0" style="margin-left:2%;margin-right: 2rem; ">
    <ng-container *ngFor="let news of rssData?.slice(0, itemsToDisplay/2)">
        <div class="categories d-flex flex-column flex-wrap align-items-center" style="flex: 1;margin: 0 10px;position: relative;">
    <div class="d-flex news-card my-2" style="position: relative; border: 1px solid #F5F5F5; box-shadow: 0px 4px 16px 0px #0000000D; width: 262px; " (click)="redirectToNews(news?.link)">
        <div class="card-img">
            <img [src]="news.image" width="100%" height="130px">
        </div>
        <div class="card-heading" style="font-weight: bold; color: black;">
            <p>{{ news.title | truncateText:45 }}</p>
        </div> 
        <div class="news-card-info" >
            <p style="text-align: left;font-size: 12px;
            font-weight: 400;
            line-height: 20px;display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;" [innerHTML]="news.description" ></p>
            <div class="view-more" style="text-align: right; position: absolute; bottom: 10px; right: 10px;">
                <span style="text-decoration: none; color: #0D6EFD;">View More</span>
            </div>
        </div>

    </div>
  </div>
  </ng-container>
</div>
<div class="d-flex justify-content-end pointer m-2 m-sm-4 view-more-mobile-view-parent laptopViewParent"  *ngIf="rssData?.length>0">
    <button class="view-more-mobile-view laptopView button-primary btn btn-primary mx-5 mx-sm-5"  style="font-family: 'Georgia' !important;font-weight: bold;" [routerLink]="['/news']">View All</button>
</div>
<div class="metrics-containers">
    <p>Glance Over Key Metrics</p>
    <div class="metrics-container">
    <div class="metrics-left">
      <img src="assets/images/glance-img.svg" alt="Key Metrics Image" class="metrics-image">
    </div>

    <div class="metrics-right">

      <div class="metrics-grid">
        <div class="metric-item">
            <div class="metric-inside">
          <div class="metric-value">{{ manufacturersCount }}</div>
          <div class="metric-label">Manufacturers</div>
        </div>
        </div>
        <div class="metric-item half-margin">
            <div class="metric-inside">
          <div class="metric-value">{{ distributorsCount }}</div>
          <div class="metric-label">Distributors</div>
        </div>
        </div>
        <div class="metric-item">
            <div class="metric-inside">
          <div class="metric-value">{{ healthcareCount }}</div>
          <div class="metric-label">Healthcare Services</div>
        </div>
        </div>
        <div class="metric-item half-margin">
            <div class="metric-inside">
          <div class="metric-value">{{ customersCount }}</div>
          <div class="metric-label">Products</div>
        </div>
        </div>
      </div>
    </div>
</div>
  </div>

<div style="margin-right: 3rem; margin-top: 5rem;" class="exhibitt" >
  </div>
        <div class="exhibit d-flex m-5 position-relative">
            <div class="txt d-flex flex-column justify-content-center" routerLink="/signup">
                <p class="exhibit-t m-0">Exhibit With Us</p>
                <p class="exhibit-b">Develop your Business!</p>
            </div>
            <div class="d-flex">
                <img src="../../assets/images/people-handshake.svg" alt="" class="handshake-image" />
            </div>

            <div class="end-txt d-flex align-items-center" style="background-image: url('../../assets/images/landingPage-bg.svg');">
                <p style="margin: 0; font-family: 'Libre Baskerville';">
                    Join us to build a more connected, innovative, and accessible medical community together
                </p>
            </div>
        </div>
    </div>

</div>
<app-website-footer></app-website-footer>
</div>
</div>
